import React, { useEffect, useMemo, useState } from "react";
import api from "@api";
import { NavLink, useParams } from "react-router-dom";
import "./DirectoryLeagueSchedule.css";

function DirectoryLeagueSchedule() {
 const { leagueNameAndId } = useParams();
 const directoryLeagueId = leagueNameAndId?.split("-").pop();
console.log('hi')
 const [schedule, setSchedule] = useState(null);
 const [league, setLeague] = useState(null);
 const [loading, setLoading] = useState(true);
 const [gameFilter, setGameFilter] = useState("all");
  const [divisionFilter, setDivisionFilter] = useState("all");

 useEffect(() => {
  const fetchLeague = async () => {
   try {
    const res = await api.get(`/api/directory/leagues/${directoryLeagueId}`);
    setLeague(res.data);
   } catch (err) {
    console.error("Failed to fetch league schedule page", err);
   } finally {
    setLoading(false);
   }
  };

  const fetchSchedule = async () => {
   try {
    const res = await api.get(
     `/api/directory/leagues/${directoryLeagueId}/schedule`
    );
    setSchedule(res.data);
   } catch (err) {
    console.error("Failed to fetch directory schedule", err);
   }
  };

  fetchLeague();
  fetchSchedule();
 }, [directoryLeagueId]);

 const formatDate = (date) => {
  if (!date) return "Date TBD";

  return new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
   month: "numeric",
   day: "numeric",
   year: "2-digit",
  });
 };

 const formatTime = (time) => {
  if (!time) return "Time TBD";

  const [hourRaw, minuteRaw] = time.split(":");
  const hour = Number(hourRaw);
  const minute = minuteRaw || "00";

  if (!Number.isFinite(hour)) return time;

  const suffix = hour >= 12 ? "PM" : "AM";
  const displayHour = hour % 12 || 12;

  return `${displayHour}:${minute} ${suffix}`;
 };

  const games = schedule?.games || [];

  const getDivisionId = (game) => {
    return (
      game.seasons_leagues_id ||
      game.seasonsLeagueId ||
      game.seasonsLeague?.id ||
      game.seasons_league?.id
    );
  };

  const getDivisionName = (game) => {
    return (
      game.seasons_league?.league?.name ||
      game.seasonsLeague?.league?.name ||
      game.seasons_league?.name ||
      game.seasonsLeague?.name ||
      game.divisionName ||
      game.leagueName ||
      `League ${getDivisionId(game)}`
    );
  };

  const divisionOptions = useMemo(() => {
    const divisionsMap = new Map();

    games.forEach((game) => {
      const divisionId = getDivisionId(game);

      if (!divisionId) return;

      divisionsMap.set(String(divisionId), getDivisionName(game));
    });

    return Array.from(divisionsMap, ([id, name]) => ({
      id,
      name,
    }));
  }, [games]);

  const filteredGames = games.filter((game) => {
    const divisionId = getDivisionId(game);

    if (divisionFilter !== "all" && String(divisionId) !== divisionFilter) {
      return false;
    }

    const homeScore = Number(game.score_home || 0);
    const awayScore = Number(game.score_away || 0);
    const hasResult = homeScore > 0 || awayScore > 0;

    const gameDate = game.date ? new Date(`${game.date}T23:59:59`) : null;
    const isPastGame = gameDate && gameDate < new Date();

    if (gameFilter === "completed") return hasResult;
    if (gameFilter === "upcoming") return !hasResult && !isPastGame;
    if (gameFilter === "pending") return !hasResult && isPastGame;

    return true;
  });

 return (
  <div className="league-profile-page">
   <div className="league-profile-container">
    <div className="league-profile-public-tabs">
     <NavLink end to={`/leagues/${leagueNameAndId}`}>
      Overview
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>
      Schedule
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
      Standings
     </NavLink>
     <NavLink to={`/leagues/${leagueNameAndId}/players`}>
      Players
     </NavLink>
    </div>

    <div className="league-profile-card directory-schedule-card">
     <div className="directory-schedule-header">
      <div>
       <h1 className="directory-schedule-title">
        {league?.name} Schedule
       </h1>
      </div>

           <div className="directory-schedule-actions">
             {divisionOptions.length > 1 && (
               <select
                 value={divisionFilter}
                 onChange={(e) => setDivisionFilter(e.target.value)}
                 className="directory-schedule-filter"
               >
                 <option value="all">All Leagues</option>

                 {divisionOptions.map((division) => (
                   <option key={division.id} value={division.id}>
                     {division.name}
                   </option>
                 ))}
               </select>
             )}

             <select
               value={gameFilter}
               onChange={(e) => setGameFilter(e.target.value)}
               className="directory-schedule-filter"
             >
               <option value="all">All Games</option>
               <option value="upcoming">Upcoming</option>
               <option value="completed">Completed</option>
               <option value="pending">Result Pending</option>
             </select>
           </div>
     </div>

     {schedule?.locked ? (
      <div className="directory-schedule-empty">
       Schedule is available with League Tools.
      </div>
     ) : filteredGames.length > 0 ? (
      <>
       <div className="directory-schedule-table">
        <div className="directory-schedule-table-header">
         <div>Date</div>
         <div>Time</div>
         <div>Matchup</div>
         <div>Location</div>
         <div>Results</div>
        </div>

        {filteredGames.map((game) => {
         const homeTeam = game.homeTeam?.team?.name || "Team TBD";
         const awayTeam = game.awayTeam?.team?.name || "Team TBD";
         const homeScore = Number(game.score_home || 0);
         const awayScore = Number(game.score_away || 0);
         const hasResult = homeScore > 0 || awayScore > 0;

         const gameDate = game.date ? new Date(`${game.date}T23:59:59`) : null;
         const isPastGame = gameDate && gameDate < new Date();

         const resultLabel = hasResult
          ? `${homeScore} - ${awayScore}`
          : isPastGame
           ? "Result pending"
           : "Upcoming";

         const resultClass = hasResult
          ? "is-completed"
          : isPastGame
           ? "is-pending"
           : "is-upcoming";

         return (
           <NavLink
             key={game.id}
             className="directory-schedule-row"
             to={`/leagues/${leagueNameAndId}/games/${game.id}`}
           >
           <div className="directory-schedule-date">
            {formatDate(game.date)}
           </div>

           <div className="directory-schedule-time">
            {formatTime(game.time)}
           </div>

           <div className="directory-schedule-matchup">
               <div className="directory-schedule-team-name">{homeTeam}</div>
               <span className="directory-schedule-vs">vs</span>
               <div className="directory-schedule-team-name">{awayTeam}</div>
           </div>

           <div className="directory-schedule-location">
            {game.location || "Location TBD"}
           </div>

           <div>
            <span className={`directory-schedule-status ${resultClass}`}>
             {resultLabel}
            </span>
           </div>
           </NavLink>
         );
        })}
       </div>

       <div className="directory-schedule-note">
        <span>ⓘ</span>
        <p>All times are local. Schedule is subject to change.</p>
       </div>
      </>
     ) : (
      <div className="directory-schedule-empty">
       No games have been added yet.
      </div>
     )}
    </div>
   </div>
  </div>
 );
}

export default DirectoryLeagueSchedule;